// src/config/api.js

export const BASE_URL = "http://localhost:8000/api/";
